<template>
  <div class="animated fadeIn">
    <b-card>
      <h1>App Logs</h1>

      <b-table
        :fields="[
          { key: 'filename', label: 'Name' },
          { key: 'size', label: 'Size' },
          { key: 'download', label: 'Download', class: 'text-center' }
        ]"
        :items="logs"
        :current-page="page"
        :per-page="perPage"
        show-empty
      >
        <template #empty>
          <div class="my-4 text-center">
            <i class="icon-docs"></i>
            <div>No logs yet</div>
            <small>must be on Nanome 1.24.5 or later</small>
          </div>
        </template>

        <template #cell(size)="{ item }">
          {{ item.size | bytes }}
        </template>

        <template #cell(download)="{ item }">
          <b-button
            class="py-0"
            variant="link"
            @click="downloadFile(item.filename, item.url)"
          >
            <i class="icon-cloud-download ml-2"></i>
          </b-button>
        </template>
      </b-table>

      <b-pagination
        v-model="page"
        :total-rows="total"
        :per-page="perPage"
        align="center"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
      />
    </b-card>
  </div>
</template>

<script>
import API from "@/api";
import { downloadFile } from "@/helpers/download";

export default {
  data: () => ({
    logs: [],
    page: 1,
    perPage: 10,
    total: 0
  }),

  mounted() {
    this.fetchLogs();
  },

  methods: {
    downloadFile,

    async fetchLogs() {
      const { success, results } = await API.getAppLogs();
      if (!success) return;
      this.logs = results.sort((a, b) => (a.filename < b.filename ? 1 : -1));
      this.total = results.length;
    }
  }
};
</script>
